import styled from 'styled-components';
import { colors } from '../../../stylesheets';

export const LoadingWrapper = styled.div((props) => ({
  // position: 'absolute',
  // transform: 'translate(calc(50% - 6rem), calc(50% - 6rem))',
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '> div[role="status"]': {
    borderColor: colors.primary,
    backgroundColor: colors.primary,
  },
}));
